import { useQuery } from 'react-query';
import api from '../services/api';

// Hook مشترک برای دریافت اطلاعات شرکت (نام، لوگو، تلفن، آدرس)
// برای استفاده در فاکتورها، هدر، و سایر بخش‌های سیستم
export function useCompany() {
  const { data, isLoading } = useQuery(
    'company-info',
    () => api.get('/companies/profile'),
    {
      staleTime: 5 * 60 * 1000, // 5 دقیقه کش
      retry: false,
    }
  );
  return {
    company: data?.data || {},
    isLoading,
  };
}

export default useCompany;
